import React from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.scss';

const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <div 
      key={location.pathname} 
      className="page-transition-wrapper"
    >
      {children}
    </div>
  );
};

export default PageTransition;